import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GatePage } from '@/pages/GatePage';
import { AboutPage } from '@/pages/AboutPage';
import { SecurityPage } from '@/pages/SecurityPage';
import { SupportPage } from '@/pages/SupportPage';
import { ReportPage } from '@/pages/ReportPage';
import { BlogPage } from '@/pages/BlogPage';
import { XtreamCubePage } from '@/pages/XtreamCubePage';
import { BlogArticlePage } from '@/pages/BlogArticlePage';
import { DeviceGuidePillarPage } from '@/pages/guides/DeviceGuidePillarPage';
import { FeaturesPillarPage } from '@/pages/guides/FeaturesPillarPage';
import { PricingPillarPage } from '@/pages/guides/PricingPillarPage';
import { DeviceSetupPage } from '@/pages/devices/DeviceSetupPage';
import { RegionalGuidePage } from '@/pages/regions/RegionalGuidePage';
import { WhatIsIPTV2026Page } from '@/pages/blog/WhatIsIPTV2026Page';
import { BestIPTVFirestick2026Page } from '@/pages/blog/BestIPTVFirestick2026Page';
import { BestIPTVUSA2026Page } from '@/pages/blog/BestIPTVUSA2026Page';
import { IPTVvsCable2026Page } from '@/pages/blog/IPTVvsCable2026Page';
import { IPTVLegalUSA2026Page } from '@/pages/blog/IPTVLegalUSA2026Page';
import { EnableDeveloperOptionsFireStickPage } from '@/pages/blog/EnableDeveloperOptionsFireStickPage';
import { FeaturedArticlesPage } from '@/pages/FeaturedArticlesPage';
import { RegionalArticlesPage } from '@/pages/RegionalArticlesPage';
import { DeviceGuidesPage } from '@/pages/DeviceGuidesPage';
import { ReviewArticlesPage } from '@/pages/ReviewArticlesPage';
import { ToolsPage } from '@/pages/ToolsPage';
import { ClusterPage } from '@/pages/ClusterPage';
import { SportsPage } from '@/pages/SportsPage';
import { LeaguePage } from '@/pages/LeaguePage';
import { TeamPage } from '@/pages/TeamPage';
import { AuthorsPage } from '@/pages/AuthorsPage';
import { SEOProtection } from '@/components/SEOProtection';

import { SiteSchema } from '@/components/SiteSchema';

function App() {
  // Capture PWA install prompt globally
  useEffect(() => {
    const handleInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      window.deferredPWA = e;

    };

    window.addEventListener('beforeinstallprompt', handleInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleInstallPrompt);
    };
  }, []);

  return (
    <div className="App">
      <SEOProtection />
      <SiteSchema />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GatePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/about/authors" element={<AuthorsPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/trusted-providers/xtreamcube" element={<XtreamCubePage />} />
          <Route path="/blog/what-is-iptv-2026" element={<WhatIsIPTV2026Page />} />
          <Route path="/blog/best-iptv-firestick-2026" element={<BestIPTVFirestick2026Page />} />
          <Route path="/blog/best-iptv-usa-2026" element={<BestIPTVUSA2026Page />} />
          <Route path="/blog/iptv-vs-cable-2026" element={<IPTVvsCable2026Page />} />
          <Route path="/blog/iptv-legal-usa" element={<IPTVLegalUSA2026Page />} />
          <Route path="/blog/enable-developer-options-fire-stick" element={<EnableDeveloperOptionsFireStickPage />} />
          <Route path="/blog/featured-articles" element={<FeaturedArticlesPage />} />
          <Route path="/blog/regions" element={<RegionalArticlesPage />} />
          <Route path="/blog/devices" element={<DeviceGuidesPage />} />
          <Route path="/blog/reviews" element={<ReviewArticlesPage />} />
          <Route path="/tools" element={<ToolsPage />} />
          <Route path="/tools/:toolId" element={<ToolsPage />} />
          {/* All other blog articles (including phase 2-5) are served dynamically from /articles via slug */}
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          <Route path="/guides/devices" element={<DeviceGuidePillarPage />} />
          <Route path="/guides/features" element={<FeaturesPillarPage />} />
          <Route path="/guides/pricing" element={<PricingPillarPage />} />

          {/* Elite SEO Pillars (Phase 3) */}
          <Route path="/guides/troubleshooting" element={<BlogArticlePage />} />
          <Route path="/guides/apps" element={<BlogArticlePage />} />
          <Route path="/guides/cable-cutting" element={<BlogArticlePage />} />
          <Route path="/guides/legal" element={<BlogArticlePage />} />
          <Route path="/guides/m3u-playlists" element={<BlogArticlePage />} />
          <Route path="/devices/:deviceId" element={<DeviceSetupPage />} />
          <Route path="/regions/:regionId" element={<RegionalGuidePage />} />
          {/* v3.5 Cluster Pages */}
          <Route path="/clusters/:clusterId" element={<ClusterPage />} />

          {/* v4.0 Sports Hub */}
          <Route path="/sports" element={<SportsPage />} />
          <Route path="/sports/:sportSlug/:leagueSlug" element={<LeaguePage />} />
          <Route path="/sports/:sportSlug/:leagueSlug/team/:teamSlug" element={<TeamPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;